import React, {FormEvent, useState} from 'react';
import {Box, Button, Link, TextField, Typography} from '@mui/material';
import api from "../../app/axios";
import LoginContainer from "../../app/components/LoginContainer";
import {useTheme} from '@mui/material/styles';

function PasswordRecovery() {
    const [email, setEmail] = useState('');
    const [showSuccessPage, setShowSuccessPage] = useState(false)
    const theme = useTheme();

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        try {
            api.post('/oapi/password_reset/', {email: email}).then(() => {
                setShowSuccessPage(true)
            })

        } catch (error) {
            console.error(error);
        }
    };

    if (!showSuccessPage) {
        return (
        <LoginContainer>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{mt: 1}}>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email"
                    name="email"
                    autoComplete="email"
                    autoFocus
                    onChange={(e) => setEmail(e.target.value)}
                />
                <Button fullWidth variant="contained" color="primary" type="submit" sx={{mt: 3, mb: 2, fontWeight:900, color: theme.palette.secondary.main}}>
                    Recuperar senha
                </Button>
                <Link color="primary" href="/" variant="body2">
                    Voltar para a página inicial
                </Link>
            </Box>
        </LoginContainer>
        );
    } else  {
        return (
        <LoginContainer>
            <Box sx={{mt: 1}}>
                <Typography variant="h4" gutterBottom>
                    E-mail enviado!
                </Typography>
                <Typography variant="body1" gutterBottom>
                    Enviamos um link de redefinição de senha para o email fornecido.
                    Verifique sua caixa de entrada e siga as instruções fornecidas no email.
                </Typography>
                <Link color="primary" href="/">
                    <Button fullWidth variant="contained" color="primary" type="submit" sx={{mt: 3, mb: 2, fontWeight:900, color: theme.palette.secondary.main}}>
                    Voltar para a página inicial
                    </Button>
                </Link>
            </Box>
        </LoginContainer>
        );
    }
}

export default PasswordRecovery;
